import {
  getMissingDataReturnBody,
  getServerErrorReturnBody,
  getSuccessReturnBody,
  getUnauthorizedReturnBody,
  MissingDataReturnBody,
  ServerErrorReturnBody,
  SuccessReturnBody,
  UnauthorizedReturnBody,
} from "src/general";
export const getPDFMissingDataMessage = "Document Id not found";

export interface GetPDFData {
  id: string;
  downloadUrl: string | null;
}

export function getPDFSuccess(getPdfData: GetPDFData): SuccessReturnBody {
  return getSuccessReturnBody(getPdfData);
}

export function getPDFMissingData(): MissingDataReturnBody {
  return getMissingDataReturnBody(getPDFMissingDataMessage);
}

export function getPDFUnauthorized(): UnauthorizedReturnBody {
  return getUnauthorizedReturnBody();
}

export function getPDFServerError(): ServerErrorReturnBody {
  return getServerErrorReturnBody();
}
